module.exports = __webpack_public_path__ + "static/img/Apps4all-white.ea28aa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apps4all/imgs/Apps4all-white.png
// module id = 853
// module chunks = 0